var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExiticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.52 1.4801H9.62C9.34385 1.4801 9.12 1.70396 9.12 1.9801L9.12 6.57148M12.9382 17.0001H9.64285C9.3667 17.0001 9.14285 16.7762 9.14285 16.5001V12.0401",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2214 20.7389V4.36465L23.35 1.8325V18.2068L13.2214 20.7389Z",
    stroke: "black",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60248 9.60244C9.85632 9.3486 9.85632 8.93704 9.60248 8.6832L5.4659 4.54663C5.21206 4.29279 4.80051 4.29279 4.54666 4.54663C4.29282 4.80047 4.29282 5.21203 4.54666 5.46587L8.22362 9.14282L4.54666 12.8198C4.29282 13.0736 4.29282 13.4852 4.54666 13.739C4.8005 13.9929 5.21206 13.9929 5.4659 13.739L9.60248 9.60244ZM-4.95562e-08 9.79282L9.14286 9.79282L9.14286 8.49282L4.95562e-08 8.49282L-4.95562e-08 9.79282Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExiticon);
export default __webpack_public_path__ + "static/media/exiticon.b701e2c371f7bffc11fd81875668729f.svg";
export { ForwardRef as ReactComponent };